import { createContext, useContext } from 'react';
export { Trans } from '@wix/wix-i18n-config';
export const TranslationContext = createContext(undefined);
export function useTranslation() {
    const context = useContext(TranslationContext);
    if (context === undefined) {
        throw new Error('useTranslation must be used within a TranslationProvider');
    }
    return context;
}

//# sourceMappingURL=translation-context.js.map